<template>
  <div>
    <div
      :class="value ? null : 'collapsed'"
      :aria-expanded="value ? 'true' : 'false'"
      :aria-controls="id"
      @click="$emit('input', !value)"
    >
      <slot name="header"> </slot>
    </div>
    <slot name="non-collapse"> </slot>

    <b-collapse :id="id" v-model="value" class="mt-2">
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>
<style lang="scss">
.pointer {
  cursor: pointer;
}
</style>
